export function multiplyBigIntByNumber(value: bigint, multiplier: number, precision = 1_000_000): bigint {
  if (Number.isNaN(multiplier)) return value
  if (multiplier === 0) return 0n
  const precisionBigInt = BigInt(precision)
  const scaledMultiplier = BigInt(Math.round(multiplier * precision))
  if (scaledMultiplier === 0n) return 0n
  return (value * scaledMultiplier) / precisionBigInt
}
